import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";
import { getQueryClient } from "../get-query-client";

export async function getApiKey() {
  const queryClient = getQueryClient();
  return await queryClient.fetchQuery({
    queryKey: ["api-key"],
    queryFn: async () => {
      const data = await authenticatedFetchJson<{ value: string }>("/api/api-key");
      return data.value || "";
    },
  });
}
